// src/components/FacebookSDKLoader.jsx
import { useEffect } from "react";

/**
 * Component สำหรับโหลด Facebook SDK และจัดการการ Render XFBML
 * รองรับการทำงานร่วมกับ React Router เมื่อมีการเปลี่ยนหน้า
 */
export default function FacebookSDKLoader() {
  useEffect(() => {
    // 1. ฟังก์ชันสำหรับสั่งให้ Facebook SDK สแกนหน้าจอและวาด Component ใหม่
    const parseXFBML = () => {
      if (window.FB) {
        try {
          window.FB.XFBML.parse();
        } catch (err) {
          console.warn("Facebook SDK parse error:", err);
        }
      }
    };

    // 2. ถ้ามี SDK โหลดไว้ในหน้าเว็บแล้ว ให้สั่ง parse ทันทีแล้วจบการทำงาน
    if (document.getElementById("facebook-jssdk")) {
      parseXFBML();
      return;
    }

    // 3. เตรียมโครงสร้าง fb-root ตามมาตรฐาน Facebook
    if (!document.getElementById("fb-root")) {
      const fbRoot = document.createElement("div");
      fbRoot.id = "fb-root";
      document.body.appendChild(fbRoot);
    }

    // 4. สร้างและโหลด Script SDK
    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    // แนะนำให้ใช้ version ล่าสุด (v21.0 หรือตามที่คุณระบุ)
    // สำหรับ appId ถ้ายังไม่มี สามารถลบ &appId=... ออกได้ SDK จะยังทำงานในโหมดทั่วไปได้
    script.src = "https://connect.facebook.net/th_TH/sdk.js#xfbml=1&version=v21.0";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";

    // เมื่อโหลด Script เสร็จครั้งแรก ให้สั่ง parse ทันที
    script.onload = () => {
      parseXFBML();
    };

    document.body.appendChild(script);
  }, []);

  return null;
}